<div class='loading-dots' role="status">
  <span class="sr-only">Loading</span>
  <div aria-hidden="true"></div>
  <div aria-hidden="true"></div>
  <div aria-hidden="true"></div>
</div>
